export default __webpack_public_path__ + "static/media/home-travel-agency-packages-img02.8e70dd1b.jpg";